import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  InputAdornment,
  TextField,
  Modal,
  Menu,
  MenuItem,
  Grid,
  Card,
  Dialog,
  DialogContent,
  Rating,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import nexticon from "../images/nexticon.png";
import menustar from "../images/menustar.png";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import axiosInstance from "./axios";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import TelegramIcon from "@mui/icons-material/Telegram";
import TwitterIcon from "@mui/icons-material/Twitter";
import grouplogo from "../images/Grouplogo.png";
import TIKTOK from "../images/TIKTOK.png";
import StarIcon from "@mui/icons-material/Star";
import google from "../images/google.png";
import PhoneIcon from "@mui/icons-material/Phone";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import InsertLinkIcon from "@mui/icons-material/InsertLink";
import LanguageIcon from "@mui/icons-material/Language";
import menuitem from "../images/menudefault.jpg";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Snackbar from "@mui/material/Snackbar";
import SnackbarContent from "@mui/material/SnackbarContent";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import imageoffer from "../images/imageoffer.png";
import { useTranslation } from "react-i18next";


const Test = () => {
  const navigate = useNavigate();
  const { code } = useParams();
  const [activeIndex, setActiveIndex] = useState(0);
  const [categoriesData, setCategoriesData] = useState([]);
  const [menuItemsData, setMenuItemsData] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [expandedItems, setExpandedItems] = useState({});
  const [getBusinessData, setGetBusinessData] = useState({});
  const [placeId, setPlaceId] = useState("");
  const [businessId, setBusinessId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const isMobile = useMediaQuery("(max-width:500px)");
  const [categoriesloading, setCategoriesLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuLoader, setMenuLoader] = useState(false);
  const currentUrl = window.location.href;
  const [Followusopen, setFollowusOpen] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const {t}=useTranslation();
  const muiTheme = useTheme();
  const themeColors = muiTheme.palette.pointGenie;
  const palette = {
    bg: themeColors.bg,
    card: themeColors.card,
    surfaceMuted: themeColors.surfaceMuted,
    cardHover: themeColors.cardHover,
    border: themeColors.border,
    textPrimary: themeColors.text,
    textSecondary: themeColors.text2,
    textMuted: themeColors.textMuted,
    textDim: themeColors.textDim,
    accent: themeColors.accent,
    accentBlue: themeColors.accentBlue,
    accentBlueBg: themeColors.accentBlueBg,
    success: themeColors.success,
    onAccent: themeColors.onAccent,
    overlayButton:
      muiTheme.palette.mode === "dark"
        ? "rgba(15,23,42,0.88)"
        : "rgba(255,255,255,0.92)",
    overlayButtonHover:
      muiTheme.palette.mode === "dark"
        ? "rgba(30,41,59,0.96)"
        : "#FFFFFF",
    shimmer:
      muiTheme.palette.mode === "dark"
        ? "linear-gradient(90deg, #111827 25%, #1E293B 50%, #111827 75%)"
        : "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
    shadow:
      muiTheme.palette.mode === "dark"
        ? "0 14px 34px rgba(0,0,0,0.34)"
        : "0 12px 26px rgba(17, 17, 17, 0.08)",
  };

  // Function to toggle modal
  const handleFollowusOpen = () => setFollowusOpen(true);
  const handleFollowusClose = () => setFollowusOpen(false);


  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    appendDots: (dots) => (
      <Box sx={{ display: "flex", justifyContent: "flex-end", pr: 2 }}>
        {dots}
      </Box>
    ),
    customPaging: (i) => (
      <Box
        sx={{
          width: 8,
          height: 8,
          bgcolor: "orange",
          borderRadius: "50%",
          opacity: 0.5,
        }}
      />
    ),
  };

  useEffect(() => {
    const fetchBusinessData = async () => {
      setLoading(true);
      setIsPageLoading(true);
      try {
        const response = await axiosInstance.post(
          "payments.php?method=fetch_business",
          { plate_code: code }
        );
        if (
          response.data?.status === "success" &&
          response.data?.place_details
        ) {
          setGetBusinessData(response.data.place_details);
        } else {
          console.error("Invalid API response structure:");
        }

        const fetchedPlaceId = response.data?.place_details?.place_id;
        if (fetchedPlaceId) {
          setPlaceId(fetchedPlaceId);
        }

        const business = response?.data?.id;
        if (business) {
          setBusinessId(business);
        }
      } catch (error) {
        console.error("API Error:", error);
      } finally {
        setLoading(false);
        setIsPageLoading(false);
      }
    };
    fetchBusinessData();
  }, [code]);
  useEffect(() => {
    if (!businessId) return;
    const fetchCategories = async () => {
      setCategoriesLoading(true);
      try {
        const response = await axiosInstance.post(
          "payments.php?method=menu_categories",
          {
            // place_id: placeId
            business_id: businessId,
          }
        );
        setCategoriesData(response.data.categories || []);
      } catch (error) {
        console.log("error");
      } finally {
        setCategoriesLoading(false);
      }
    };

    fetchCategories();
  }, [businessId]);

  useEffect(() => {
    if (categoriesData.length > 0) {
      menuItems(categoriesData[0].category_id);
    }
  }, [categoriesData]);

  const menuItems = async (category_id) => {
    setSearchTerm("");
    setMenuLoader(true);
    try {
      const itemResponse = await axiosInstance.post(
        "payments.php?method=category_menu_items",
        {
          business_id: businessId,
          business_menu_category_id: category_id,
        }
      );
      setMenuItemsData(itemResponse.data.items || []);
    } catch {
      console.log("error");
    }
    setMenuLoader(false);
  };

  const displayedMenuItems = searchTerm
    ? menuItemsData.filter(
        (item) =>
          item.menu_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.menu_description.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : menuItemsData;

  const handleToggle = (index) => {
    setExpandedItems((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const handleOpen = (item) => {
    setSelectedItem(item);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedItem(null);
    setAnchorEl(null);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClosesocialmedia = () => {
    setAnchorEl(null);
  };

  const handleSocialClick = (platform) => {
    let shareUrl = "";

    switch (platform) {
      case "whatsapp":
        shareUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(
          currentUrl
        )}`;
        break;
      case "instagram":
        shareUrl = `https://www.instagram.com/`; // Instagram doesn't allow direct text sharing
        break;
      case "facebook":
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          currentUrl
        )}`;
        break;
      case "twitter":
        shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
          currentUrl
        )}`;
        break;
      case "telegram":
        shareUrl = `https://t.me/share/url?url=${encodeURIComponent(
          currentUrl
        )}`;
        break;
      default:
        break;
    }

    // Open the URL in a new tab
    if (shareUrl) {
      window.open(shareUrl, "_blank");
    }

    handleClosesocialmedia(); // Close the dropdown after clicking
  };
  const handleCopy = (text) => {
    if (text) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          setOpenSnackbar(true);
        })
        .catch((err) => {
          console.error("Failed to copy text: ", err);
        });
    }
  };

  const handleProviderClick = async(item)=>
    {
      if (
        item.provider.toLowerCase() ===
        "whatsapp"
      ) {
        const whatsappUrl = `https://wa.me/${item.providerUrl.replace(
          /\D/g,
          ""
        )}`;
        window.open(
          whatsappUrl,
          "_blank"
        );
      } else {
        window.open(
          item.providerUrl.startsWith(
            "http"
          )
            ? item.providerUrl
            : `https://${item.providerUrl}`,
          "_blank"
        );
      }
      try {
        await axiosInstance.post("payments.php?method=provider_clicks", {
          business_id: businessId,
          provider: item.provider,
        });
      } catch (error) {
        console.error("providerclicking failed", error);
      }
    }



    const handleGoogleProviderClick =async ()=>
    {
        const fallbackUrl = getBusinessData?.provider?.google?.proivder_link;
        const url =  fallbackUrl
      if (!url) return; // Do nothing if no valid URL
        window.open(url, "_blank");
      try {
        await axiosInstance.post("payments.php?method=provider_clicks", {
          business_id: businessId,
          provider: "google",
        });
      } catch (error) {
        console.error("providerclicking failed", error);
      }   
    }



    const  formatReviewCount= (count) =>{
      if (!count && count !== 0) return '';
      if (count >= 1000) {
        return `${(count / 1000).toFixed(1).replace(/\.0$/, '')}k`;
      }
      return count;
    }

    const getItemName = (item) => item?.menu_name || "";
    const getItemDescription = (item) => item?.menu_description || "";
    const getItemPrice = (item) => {
      if (!item?.price && item?.price !== 0) return "";
      return String(item.price).startsWith("$") ? item.price : `$${item.price}`;
    };
  

  return (
    <Box
      sx={{
        pb: "40px",
        minHeight: "100vh",
        bgcolor: palette.bg,
        color: palette.textPrimary,
        maxWidth: "430px",
        mx: "auto",
      }}
    >
      {isPageLoading ? (
        <Box
          sx={{
            width: "100%",
            minHeight: "100vh",
            backgroundColor: palette.bg,
            padding: "20px",
          }}
        >
          <Box sx={{ display: "flex ", justifyContent: "space-between" }}>
            <Typography
              sx={{
                width: "28px",
                height: "28px",
                background: palette.shimmer,
                backgroundSize: "200% 100%",
                animation: "shimmer 1.8s infinite",
                borderRadius: "25px",
                "@keyframes shimmer": {
                  "0%": { backgroundPosition: "-200% 0" },
                  "100%": { backgroundPosition: "200% 0" },
                },
              }}
            ></Typography>
            <Box display={"flex"} alignItems={"center"} gap={"3px"}>
              <Typography
                sx={{
                  width: "28px",
                  height: "28px",
                  background:
                    palette.shimmer,
                  backgroundSize: "200% 100%",
                  animation: "shimmer 1.8s infinite",
                  borderRadius: "25px",
                  "@keyframes shimmer": {
                    "0%": { backgroundPosition: "-200% 0" },
                    "100%": { backgroundPosition: "200% 0" },
                  },
                }}
              ></Typography>
              <Typography
                sx={{
                  width: "40px",
                  height: "20px",
                  background:
                    palette.shimmer,
                  backgroundSize: "200% 100%",
                  animation: "shimmer 1.8s infinite",
                  borderRadius: "6px",
                  "@keyframes shimmer": {
                    "0%": { backgroundPosition: "-200% 0" },
                    "100%": { backgroundPosition: "200% 0" },
                  },
                }}
              ></Typography>
            </Box>
          </Box>
          <Box
            sx={{
              border: `2px solid ${palette.border}`,
              borderRadius: "8px",
              p: "10px",
              mt: "10px",
            }}
          >
            <Typography
              sx={{
                width: "160px",
                height: "18px",
                background: palette.shimmer,
                backgroundSize: "200% 100%",
                animation: "shimmer 1.8s infinite",
                borderRadius: "6px",
                "@keyframes shimmer": {
                  "0%": { backgroundPosition: "-200% 0" },
                  "100%": { backgroundPosition: "200% 0" },
                },
              }}
            ></Typography>

            <Typography
              sx={{
                width: "150px",
                height: "20px",
                mt: "10px",
                background: palette.shimmer,
                backgroundSize: "200% 100%",
                animation: "shimmer 1.8s infinite",
                borderRadius: "6px",
                "@keyframes shimmer": {
                  "0%": { backgroundPosition: "-200% 0" },
                  "100%": { backgroundPosition: "200% 0" },
                },
              }}
            ></Typography>

            <Typography
              sx={{
                width: "150px",
                height: "20px",
                mt: "10px",
                background: palette.shimmer,
                backgroundSize: "200% 100%",
                animation: "shimmer 1.8s infinite",
                borderRadius: "6px",
                "@keyframes shimmer": {
                  "0%": { backgroundPosition: "-200% 0" },
                  "100%": { backgroundPosition: "200% 0" },
                },
              }}
            ></Typography>
          </Box>
          {/* Shimmer Text */}
          <Box
            sx={{
              width: "100%",
              height: "70px",
              mt: "15px",
              background: palette.shimmer,
              backgroundSize: "200% 100%",
              animation: "shimmer 1.8s infinite",
              borderRadius: "14px",
              "@keyframes shimmer": {
                "0%": { backgroundPosition: "-200% 0" },
                "100%": { backgroundPosition: "200% 0" },
              },
            }}
          />
        </Box>
      ) : (
        <Box
          sx={{
            backgroundColor: palette.bg,
            borderRadius: "0px 0px 28px 28px",
            pb: "20px",
          }}
        >
          <Box sx={{ position: "relative" }}>
            <Box
              sx={{ width: "100%", height: "45px", position: "relative" }}
            ></Box>
            <Box sx={{ position: "absolute", top: "15px", width: "100%" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  px: "18px",
                  width: "100%",
                }}
              >
                <IconButton
                  onClick={() => navigate(`/place/${code}`)}
                  sx={{
                    backgroundColor: palette.overlayButton,
                    color: palette.textPrimary,
                    borderRadius: "50%",
                    width: "25px",
                    height: "25px",
                    boxShadow: palette.shadow,
                    "&:hover": {
                      backgroundColor: palette.overlayButtonHover,
                    },
                  }}
                >
                  <ArrowBackIosIcon sx={{ color: palette.textPrimary, fontSize: 20 }} />
                </IconButton>
                <Box>
                  <Box display={"flex"} gap={0.5} alignItems={"center"}>
                    <Box
                      component="img"
                      src={nexticon}
                      width={"32px"}
                      height={"32px"}
                      onClick={handleClick}
                      sx={{ cursor: "pointer" }}
                    />
                    <Typography
                      sx={{
                        fontFamily: "Roboto",
                        fontSize: "14px",
                        fontWeight: "500",
                        letterSpacing: "0px",
                        lineHeight: "14px",
                        color: palette.textPrimary,
                      }}
                      onClick={handleClick}
                    >
                      {t("Share")}
                    </Typography>
                    {/* Dropdown Menu */}
                    {/* <ClickAwayListener onClickAway={handleClose}> */}
                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={handleClose}
                      PaperProps={{
                        sx: {
                          mt: 1,
                          borderRadius: "8px",
                          backgroundColor: palette.card,
                          color: palette.textPrimary,
                          border: `1px solid ${palette.border}`,
                          boxShadow: palette.shadow,
                          width: "200px",
                          p: "5px",
                        },
                      }}
                    >
                      {/* WhatsApp */}
                      <MenuItem
                        onClick={() => handleSocialClick("whatsapp")}
                        sx={{ gap: 1 }}
                      >
                        <WhatsAppIcon sx={{ color: "#25D366" }} />
                        <Typography>WhatsApp</Typography>
                      </MenuItem>

                      {/* Instagram */}
                      <MenuItem
                        onClick={() => handleSocialClick("instagram")}
                        sx={{ gap: 1 }}
                      >
                        <InstagramIcon sx={{ color: "#E4405F" }} />
                        <Typography>Instagram</Typography>
                      </MenuItem>

                      {/* {facebook} */}

                      <MenuItem
                        onClick={() => handleSocialClick("facebook")}
                        sx={{ gap: 1 }}
                      >
                        <FacebookIcon sx={{ color: "#E4405F" }} />
                        <Typography>Facebook</Typography>
                      </MenuItem>

                      {/* Twitter */}
                      <MenuItem
                        onClick={() => handleSocialClick("twitter")}
                        sx={{ gap: 1 }}
                      >
                        <TwitterIcon sx={{ color: "#1DA1F2" }} />
                        <Typography>Twitter</Typography>
                      </MenuItem>

                      {/* Telegram */}
                      <MenuItem
                        onClick={() => handleSocialClick("telegram")}
                        sx={{ gap: 1 }}
                      >
                        <TelegramIcon sx={{ color: "#0088CC" }} />
                        <Typography>Telegram</Typography>
                      </MenuItem>
                    </Menu>
                    {/* </ClickAwayListener> */}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
          <Box sx={{ paddingRight: "0px", paddingTop: "12px" }}></Box>
          <Card
            sx={{
              gap: "4px",
              display: "flex",
              alignItems: "start",
              mx: "18px",
              py: "14px",
              border: `1px solid ${palette.border}`,
              borderRadius: "20px",
              boxShadow: palette.shadow,
              backgroundColor: palette.card,
              //   mb:"10px"
            }}
          >
            <Box sx={{ px: "15px", width: "100%" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "8px",
                  alignItems: "center",
                }}
              >
                {loading ? (
                  <Box
                    sx={{
                      width: "180px",
                      height: "18px",
                      background:
                        palette.shimmer,
                      backgroundSize: "200% 100%",
                      animation: "shimmer 1.5s infinite",
                      borderRadius: "4px",
                      "@keyframes shimmer": {
                        "0%": { backgroundPosition: "-200% 0" },
                        "100%": { backgroundPosition: "200% 0" },
                      },
                    }}
                  />
                ) : (
                  <Typography
                    sx={{
                      fontFamily: "Roboto",
                      fontSize: "20px",
                      fontWeight: "800",
                      letterSpacing: "0px",
                      lineHeight: "24px",
                      color: palette.textPrimary,
                      wordBreak: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {getBusinessData?.name}
                  </Typography>
                )}
              </Box>
              <Grid container gap={"5px"} justifyContent={"space-between"}>
                <Grid xs={12}>
                  <Box display={"flex"} gap={0.8} pt={"6px"}>
                    {loading ? (
                      <Box
                        sx={{
                          width: "160px",
                          height: "16px",
                      background: palette.shimmer,
                          backgroundSize: "200% 100%",
                          animation: "shimmer 1.5s infinite",
                          borderRadius: "4px",
                          "@keyframes shimmer": {
                            "0%": { backgroundPosition: "-200% 0" },
                            "100%": { backgroundPosition: "200% 0" },
                          },
                        }}
                      />
                    ) : (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                          gap: "5px",
                          alignItems: "center",
                        }}
                      >
                        <Box sx={{ width: "50%" }}>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              flexDirection:'column',
                              gap: "2px",
                            }}
                          >
                            {/* <Box component="img" src={menustar} pt={"2px"} /> */}
                            <Typography
                              sx={{
                                fontSize: "14px",
                                fontWeight: "400",
                                fontFamily: "Roboto",
                                // lineHeight: "25.88px",
                                letterSpacing: "-0.65px",
                                color: "#F97731",
                                display: "flex",
                                alignItems: "center",
                                gap:"5px"
                              }}
                            >
                            {getBusinessData?.rating &&
                          (parseFloat(getBusinessData.rating) % 1 === 0
                            ? `${parseFloat(getBusinessData.rating).toFixed(1)}`
                            : getBusinessData.rating)}

                        <Rating
                          value={parseFloat(getBusinessData.rating)}
                          readOnly
                          precision={0.1}
                          sx={{ fontSize: "12px" }}
                        />
                         </Typography>
                              <Box
                                component="span"
                                sx={{
                                  fontSize: "14px",
                                  fontWeight: "500",
                                  fontFamily: "Roboto",
                                  // lineHeight: "25.88px",
                                  letterSpacing: "-0.3px",
                                  color: palette.textMuted,
                                  paddingLeft: "1px",
                                }}
                              >
                                 ({formatReviewCount(getBusinessData?.review_count)} reviews)
                              </Box>
                            
                          </Box>
                          {loading ? (
                            <Box
                              sx={{
                                width: "160px",
                                height: "16px",
                                background: palette.shimmer,
                                backgroundSize: "200% 100%",
                                animation: "shimmer 1.5s infinite",
                                borderRadius: "4px",
                                mt: "4px",
                                "@keyframes shimmer": {
                                  "0%": { backgroundPosition: "-200% 0" },
                                  "100%": { backgroundPosition: "200% 0" },
                                },
                              }}
                            />
                          ) : (
                            <>
                              {getBusinessData?.website && (
                                <Box>
                                  <Typography
                                    sx={{
                                      fontFamily: "Roboto",
                                      fontSize: "14px",
                                      fontWeight: "500",
                                      letterSpacing: "0px",
                                      lineHeight: "14px",
                                      color: palette.accent,
                                      wordBreak: "break-word",
                                      overflowWrap: "break-word",
                                    }}
                                  >
                                    <a
                                      href={getBusinessData?.website}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{
                                        textDecoration: "none",
                                        color: "inherit",
                                      }}
                                    >
                                      <LanguageIcon
                                        sx={{
                                          color: palette.accent,
                                          fontSize: "18px",
                                          mr: "4px",
                                        }}
                                      />
                                     {t("Website")}
                                    </a>
                                  </Typography>
                                </Box>
                              )}

                              <Box
                                display={"flex"}
                                gap={0.8}
                                pt={"4px"}
                                pb={"8px"}
                              >
                                {/* <Box component="img" src={call} width={"14px"} height={"14px"} /> */}
                                <PhoneIcon
                                  fontSize="14px"
                                  sx={{ color: palette.accent }}
                                />
                                <Typography
                                  sx={{
                                    fontFamily: "Roboto",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    letterSpacing: "0px",
                                    lineHeight: "14px",
                                    color: palette.accent,
                                    cursor: "pointer",
                                    wordBreak: "break-word",
                                    overflowWrap: "break-word",
                                  }}
                                  onClick={() =>
                                    window.open(
                                      `tel:${getBusinessData.telephone}`
                                    )
                                  }
                                >
                                  {getBusinessData?.telephone ||
                                    "No phone number available"}
                                </Typography>
                              </Box>
                            </>
                          )}
                        </Box>
                        <Box sx={{ width: "50%" }}>
                          <Box sx={{ textAlign: "center" }}>
                           { getBusinessData?.provider?.google &&(
                             <Button
                              sx={{
                                color: palette.onAccent,
                                width: "100%",
                                fontSize: "9px",
                                fontFamily: "Roboto",
                                fontWeight: "500",
                                backgroundColor: palette.accent,
                                textTransform: "capitalize",
                                borderRadius: "8px",
                                py: "6px",
                                "@media (max-width:367px)": {
                                  width: "100%",
                                  px: "0px",
                                },
                              }}
                              onClick={() => handleGoogleProviderClick()}
                            >
                              <img
                                src={google}
                                alt="Google"
                                style={{
                                  width: "12px",
                                  height: "auto",
                                  marginRight: "6px",
                                }}
                              />
                              {t("Leave us a Google Review")}
                            </Button>
                           )}
                            {getBusinessData?.provider &&
                              Object.keys(getBusinessData.provider).length >
                                0 && (
                                <Button
                                  sx={{
                                    color: "white",
                                    width: "100%",
                                    fontSize: "10px",
                                    fontFamily: "Roboto",
                                    fontWeight: "500",
                                    backgroundColor: palette.accent,
                                    textTransform: "capitalize",
                                    borderRadius: "8px",
                                    py: "6px",
                                    mt: "4px",
                                    "@media (max-width:367px)": {
                                      width: "100%",
                                      px: "0px",
                                    },
                                    "& > svg": {
                                      mr: "1px", // Adds space between text and first icon
                                    },
                                  }}
                                  onClick={handleFollowusOpen}
                                >
                                  <KeyboardDoubleArrowRightIcon
                                    sx={{ fontSize: "18px", ml: "0px" }}
                                  />
                                  {t("Connect With Us")}
                                </Button>
                              )}
                          </Box>
                          <Dialog
                            open={Followusopen}
                            onClose={handleFollowusClose}
                            fullWidth
                            maxWidth="sm"
                          >
                            <DialogContent
                              sx={{ p: "20px", position: "relative" }}
                            >
                              {/* Close Icon at Top Right Corner */}
                              <IconButton
                                onClick={handleFollowusClose}
                                sx={{
                                  position: "absolute",
                                  top: 1,
                                  right: 1,
                                  color: "black",
                                }}
                              >
                                <CloseIcon sx={{fontSize:"18px",}} />
                              </IconButton>

                              {/* Heading Text */}
                              <Typography
                                sx={{
                                  fontSize: "14px",
                                  fontFamily: "Roboto",
                                  color: "gray",
                                  mb: 2,
                                  mt:1,
                                }}
                              >
                                {t("Connect With Us Share Your Feedback. Your Opinion Matters to Us!")}
                              </Typography>

                              {/* Social Media Links */}
                              {getBusinessData?.provider &&
                                (() => {
                                  const validProviders = Object.entries(
                                    getBusinessData.provider
                                  )
                                    .filter(
                                      ([provider, data]) =>
                                        data.proivder_link &&
                                        provider.toLowerCase() !== "google"
                                    )
                                    .map(([provider, data]) => {
                                      let providerIcon;
                                      let providerName = data.proivder_label; // Use the label from data
                                      let providerUrl = data.proivder_link; // Use the link from data
                                      if (provider.toLowerCase() === "yelp") {
                                        providerIcon = (
                                          <StarIcon
                                            sx={{
                                              color: "#D32323",
                                              fontSize: 30,
                                            }}
                                          />
                                        );
                                      } else if (
                                        provider.startsWith("customprovider_")
                                      ) {
                                        providerIcon = (
                                          <InsertLinkIcon
                                            sx={{
                                              color: palette.accent,
                                              fontSize: 30,
                                            }}
                                          />
                                        );
                                      } else {
                                        switch (provider.toLowerCase()) {
                                          case "facebook":
                                            providerIcon = (
                                              <FacebookIcon
                                                sx={{
                                                  color: "#1877F2",
                                                  fontSize: 30,
                                                }}
                                              />
                                            );
                                            providerName = "Facebook";
                                            break;
                                          case "instagram":
                                            providerIcon = (
                                              <InstagramIcon
                                                sx={{
                                                  color: "#E4405F",
                                                  fontSize: 30,
                                                }}
                                              />
                                            );
                                            providerName = "Instagram";
                                            break;
                                          case "tiktok":
                                            providerIcon = (
                                              <Box
                                                component="img"
                                                src={TIKTOK}
                                                sx={{ width: 30, height: 30 }}
                                              />
                                            );
                                            providerName = "TikTok";
                                            break;
                                          case "whatsapp":
                                            providerIcon = (
                                              <WhatsAppIcon
                                                sx={{
                                                  color: "#25D366",
                                                  fontSize: 30,
                                                }}
                                              />
                                            );
                                            providerName = "WhatsApp";
                                            break;
                                          case "yelp":
                                            providerIcon = (
                                              <StarIcon
                                                sx={{
                                                  color: "#D32323",
                                                  fontSize: 30,
                                                }}
                                              />
                                            );
                                            providerName = "Yelp";
                                            break;
                                          case "tripadvisor":
                                            providerIcon = (
                                              <StarIcon
                                                sx={{
                                                  color: "#00AF87",
                                                  fontSize: 30,
                                                }}
                                              />
                                            );
                                            providerName = "TripAdvisor";
                                            break;
                                          case "pointgenie":
                                            providerIcon = (
                                              <Box
                                                component="img"
                                                src={grouplogo}
                                                sx={{ width: 30, height: 30 }}
                                              />
                                            );
                                            providerName = "PointGenie";
                                            break;
                                          default:
                                            return null;
                                        }
                                      }
                                      return {
                                        provider,
                                        providerUrl,
                                        providerIcon,
                                        providerName,
                                      };
                                    })
                                    .filter(Boolean); // Remove nulls

                                  const pairs = [];
                                  for (
                                    let i = 0;
                                    i < validProviders.length;
                                    i += 2
                                  ) {
                                    pairs.push(validProviders.slice(i, i + 2));
                                  }

                                  return pairs.map((pair, index) => (
                                    <Grid
                                      container
                                      key={index}
                                      sx={{
                                        px: { xs: "", sm: "20px" },
                                        mb: "5px",
                                        gap: "4px",
                                      }}
                                    >
                                      {pair.map((item) => (
                                        <Grid
                                          item
                                          // xs={
                                          //   pair.length === 1 &&
                                          //   validProviders.length > 2
                                          //     ? 12
                                          //     : 5.8
                                          // }
                                          xs={pair.length === 1 && (validProviders.length === 1 || validProviders.length % 2 !== 0) ? 12 : 5.8}

                                          key={item.provider}
                                          sx={{
                                            border: `1px solid ${palette.accent}`,
                                            borderRadius: "8px",
                                            py: "2px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            cursor: "pointer",
                                            gap: "6px",
                                          }}
                                          onClick={()=>handleProviderClick(item)}
                                        >
                                          <Box
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                            }}
                                          >
                                            {item.providerIcon}
                                          </Box>
                                          <Typography
                                            sx={{
                                              fontSize: {
                                                xs: "13px",
                                                sm: "14px",
                                              },
                                              fontWeight: "700",
                                              fontFamily: "Roboto",
                                              lineHeight: "14px",
                                              color: palette.accent,
                                            }}
                                          >
                                            {item.providerName}
                                          </Typography>
                                        </Grid>
                                      ))}
                                    </Grid>
                                  ));
                                })()}
                            </DialogContent>
                          </Dialog>
                        </Box>
                      </Box>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Card>
        </Box>
      )}

      {getBusinessData?.specials?.length > 0 && (
        <Box
          sx={{ borderRadius: 2, overflow: "hidden", mx: "20px", mt: "10px" }}
        >
          <Slider {...settings}>
            {getBusinessData?.specials?.map((coupon, index) => (
              <Box
                key={coupon.id}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  px: 2,
                  py: 2,
                  border: `1px solid ${palette.border}`,
                  borderRadius: "20px",
                  backgroundColor: palette.card,
                  color: palette.textPrimary,
                  flexDirection: "row",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexGrow: 1,
                  }}
                >
                  <Box sx={{ display: "flex", gap: "8px" }}>
                    <Box
                      component="img"
                      src={coupon.image || imageoffer}
                      width={"30px"}
                      height={"30px"}
                      borderRadius={"25px"}
                      sx={{ objectFit: "cover" }}
                    />
                    <Box>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          cursor: "pointer",
                          textTransform: "capitalize",
                          fontWeight: "bold",
                          fontSize: "16px",
                          fontFamily: "Roboto",
                          lineHeight: "18px",
                          color: palette.textPrimary,
                        }}
                      >
                        {coupon.menu_name}
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{
                          cursor: "pointer",
                          textTransform: "capitalize",
                          fontWeight: "medium",
                          fontSize: "12px",
                          fontFamily: "Roboto",
                          lineHeight: "14px",
                          color: palette.textMuted,
                        }}
                      >
                        <Typography
                          component={"span"}
                          sx={{
                            cursor: "pointer",
                            textTransform: "capitalize",
                            fontWeight: "medium",
                            fontSize: "12px",
                            fontFamily: "Roboto",
                            lineHeight: "14px",
                            color: palette.textPrimary,
                          }}
                        >
                          {coupon?.coupon_code?.replace(/"/g, '')}{" "}
                          <ContentCopyIcon
                            sx={{ fontSize: "15px", mx: "3px" }}
                            onClick={() => handleCopy(coupon?.coupon_code)}
                          />{" "}
                        </Typography>{" "}
                        | Before {coupon.expiration_date}
                      </Typography>
                    </Box>
                  </Box>
                  <Typography
                    sx={{
                      color: "orange",
                      fontWeight: "bold",
                      fontSize: "14px",
                      fontFamily: "Roboto",
                    }}
                  >
                    {`${index + 1}/${getBusinessData?.specials?.length}`}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Slider>
        </Box>
      )}
      {categoriesData?.length > 0 && (
        <Box sx={{ px: "18px", pt: "18px" }}>
          <Typography
            sx={{
              fontFamily: "Roboto",
              fontSize: "19px",
              fontWeight: "800",
              lineHeight: "22px",
              color: palette.textPrimary,
            }}
          >
            {t("Menu")}
          </Typography>
        </Box>
      )}
      <Box
        sx={{
          px: "18px",
          pt: "12px",
          pb: "4px",
        }}
      >
        {categoriesloading ? (
          <Box sx={{ display: "flex", gap: 1, overflow: "hidden" }}>
            {[...Array(5)].map((_, index) => (
              <Box
                key={index}
                sx={{
                  width: "86px",
                  height: "34px",
                  background: palette.shimmer,
                  backgroundSize: "200% 100%",
                  animation: "shimmer 1.5s infinite",
                  borderRadius: "999px",
                  flexShrink: 0,
                  "@keyframes shimmer": {
                    "0%": { backgroundPosition: "-200% 0" },
                    "100%": { backgroundPosition: "200% 0" },
                  },
                }}
              />
            ))}
          </Box>
        ) : (
          <Tabs
            value={activeIndex}
            onChange={(e, newValue) => {
              setActiveIndex(newValue);
              menuItems(categoriesData[newValue].category_id, newValue);
            }}
            variant="scrollable"
            scrollButtons={false}
            sx={{
              minHeight: 0,
              "& .MuiTabs-flexContainer": {
                gap: "8px",
              },
              "& .MuiTab-root": {
                minHeight: 0,
                px: "16px",
                py: "8px",
                borderRadius: "999px",
                border: `1px solid ${palette.border}`,
                bgcolor: palette.card,
                color: palette.textMuted,
                textTransform: "capitalize",
                fontWeight: "700",
                fontSize: "13px",
                fontFamily: "Roboto",
              },
              "& .MuiTab-root.Mui-selected": {
                color: palette.onAccent,
                bgcolor: palette.accent,
                borderColor: palette.accent,
              },
              "& .MuiTabs-indicator": {
                display: "none",
              },
            }}
          >
            {categoriesData.map((category) => (
              <Tab key={category.category_id} label={category.name} />
            ))}
          </Tabs>
        )}
      </Box>
      <Box sx={{ px: "18px", pt: "12px" }}>
        {menuItemsData?.length > 0 && (
          <TextField
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            type="search"
            variant="outlined"
            placeholder="Search dishes, services, or specials"
            size="small"
            fullWidth
            sx={{
              bgcolor: palette.card,
              borderRadius: "999px",
              "& .MuiOutlinedInput-root": {
                borderRadius: "999px",
                height: "42px",
                fontFamily: "Roboto",
                fontSize: "14px",
              },
              "& fieldset": {
                borderColor: palette.border,
              },
            }}
            InputProps={{
              sx: {
                pr: "6px",
              },
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    sx={{
                      backgroundColor: palette.accent,
                      color: palette.onAccent,
                      width: "30px",
                      height: "30px",
                      "&:hover": { backgroundColor: palette.accentBlue },
                    }}
                  >
                    <SearchIcon sx={{ fontSize: "17px" }} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        )}
      </Box>

      <Box sx={{ px: "18px", pt: "16px", pb: "10px" }}>
        {menuLoader ? (
          Array.from({ length: 4 }).map((_, index) => (
            <Box
              key={index}
              sx={{
                border: `1px solid ${palette.border}`,
                borderRadius: "10px",
                px: "12px",
                py: "10px",
                display: "flex",
                gap: "10px",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
                <Box
                  sx={{
                    width: "120px",
                    height: "16px",
                    borderRadius: "4px",
                    background: palette.shimmer,
                    backgroundSize: "200% 100%",
                    animation: "shimmer 1.5s infinite",
                  }}
                />
                <Box
                  sx={{
                    width: "80px",
                    height: "14px",
                    borderRadius: "4px",
                    background: palette.shimmer,
                    backgroundSize: "200% 100%",
                    animation: "shimmer 1.5s infinite",
                    mt: "10px",
                  }}
                />
                <Box
                  sx={{
                    width: "150px",
                    height: "14px",
                    borderRadius: "4px",
                    background: palette.shimmer,
                    backgroundSize: "200% 100%",
                    animation: "shimmer 1.5s infinite",
                    mt: "8px",
                  }}
                />
              </Box>
              <Box
                sx={{
                  width: "100px",
                  height: "93px",
                  borderRadius: "6px",
                  background: palette.shimmer,
                  backgroundSize: "200% 100%",
                  animation: "shimmer 1.5s infinite",
                }}
              />
            </Box>
          ))
        ) : menuItemsData === null ? (
          <></>
        ) : menuItemsData && displayedMenuItems.length > 0 ? (
          displayedMenuItems.map((item, index) => (
            <Box
              key={item.id || index}
              onClick={() => handleOpen(item)}
              sx={{
                bgcolor: palette.card,
                border: `1px solid ${palette.border}`,
                borderRadius: "22px",
                overflow: "hidden",
                mb: "16px",
                boxShadow: palette.shadow,
                cursor: "pointer",
              }}
            >
              <Box
                sx={{
                  position: "relative",
                  width: "100%",
                  aspectRatio: "16 / 10",
                  bgcolor: palette.surfaceMuted,
                  overflow: "hidden",
                }}
              >
                <Box
                  component="img"
                  src={item.image || menuitem}
                  alt={getItemName(item) || "Menu item"}
                  sx={{
                    display: "block",
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
                <Box
                  sx={{
                    position: "absolute",
                    left: "12px",
                    bottom: "12px",
                    px: "10px",
                    py: "5px",
                    borderRadius: "999px",
                    bgcolor: palette.accentBlueBg,
                    color: palette.accentBlue,
                    fontSize: "13px",
                    fontWeight: "800",
                    fontFamily: "Roboto",
                    boxShadow: "0 5px 14px rgba(0,0,0,0.14)",
                  }}
                >
                  {getItemPrice(item)}
                </Box>
              </Box>
              <Box sx={{ p: "14px 15px 15px" }}>
                <Typography
                  sx={{
                    fontFamily: "Roboto",
                    fontSize: "16px",
                    fontWeight: "800",
                    lineHeight: "20px",
                    color: palette.textPrimary,
                    textTransform: "capitalize",
                  }}
                >
                  {getItemName(item)}
                </Typography>
                {getItemDescription(item) && (
                  <Typography
                    sx={{
                      mt: "7px",
                      fontFamily: "Roboto",
                      fontSize: "13px",
                      fontWeight: "400",
                      lineHeight: "18px",
                      color: palette.textMuted,
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                    }}
                  >
                    {getItemDescription(item)}
                  </Typography>
                )}
                <Box
                  sx={{
                    mt: "12px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "12px",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Roboto",
                      fontSize: "15px",
                      fontWeight: "800",
                      lineHeight: "16px",
                      color: palette.accent,
                    }}
                  >
                    {getItemPrice(item)}
                  </Typography>
                  <Button
                    size="small"
                    sx={{
                      minWidth: "92px",
                      borderRadius: "999px",
                      px: "14px",
                      py: "6px",
                      bgcolor: palette.accent,
                      color: palette.onAccent,
                      fontFamily: "Roboto",
                      fontSize: "12px",
                      fontWeight: "800",
                      textTransform: "none",
                      "&:hover": { bgcolor: palette.accentBlue },
                    }}
                  >
                    View details
                  </Button>
                </Box>
              </Box>
            </Box>
          ))
        ) : (
          <Typography
            sx={{
              fontFamily: "Roboto",
              fontSize: "16px",
              fontWeight: "500",
              lineHeight: "16px",
              color: palette.textMuted,
              textAlign: "center",
            }}
          >
           {t("No Items available")}
          </Typography>
        )}
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", px: "20px" }}></Box>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={2000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <SnackbarContent
          message={
            <Box display="flex" alignItems="center" gap={1}>
              <CheckCircleIcon
                sx={{
                  fontSize: 20,
                  color: "white",
                  cursor: "pointer",
                }}
              />
              <span>Coupon code copied</span>
            </Box>
          }
          sx={{
            backgroundColor: "green",
            color: "#fff",
            borderRadius: "8px",
            fontWeight: 500,
            fontFamily: "Roboto",
            py: "0px",
          }}
        />
      </Snackbar>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "fixed",
            bottom: 0,
            left: "50%",
            transform: "translateX(-50%)",
            width: "100%",
            maxWidth: "430px",
            bgcolor: palette.card,
            color: palette.textPrimary,
            boxShadow: "0 -18px 50px rgba(0,0,0,0.28)",
            pb: "28px",
            borderTopLeftRadius: "30px",
            borderTopRightRadius: "30px",
            maxHeight: "94vh",
            overflowY: "auto",
          }}
        >
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 14,
              right: 14,
              color: palette.textPrimary,
              backgroundColor: palette.overlayButton,
              width: "32px",
              height: "32px",
              zIndex: 2,
              boxShadow: "0 4px 14px rgba(0,0,0,0.16)",
            }}
          >
            <CloseIcon sx={{ fontSize: "18px" }} />
          </IconButton>
          {selectedItem && (
            <>
              <Box
                sx={{
                  width: "100%",
                  aspectRatio: "4 / 3",
                  maxHeight: "52vh",
                  bgcolor: palette.surfaceMuted,
                  overflow: "hidden",
                  borderTopLeftRadius: "30px",
                  borderTopRightRadius: "30px",
                }}
              >
                <Box
                  component="img"
                  src={selectedItem.image || menuitem}
                  alt={getItemName(selectedItem) || "Menu item"}
                  sx={{
                    display: "block",
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    mx: "auto",
                  }}
                />
              </Box>
              <Box
                sx={{
                  px: "20px",
                  pt: "18px",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Roboto",
                    fontSize: "20px",
                    fontWeight: "800",
                    lineHeight: "24px",
                    color: palette.textPrimary,
                    textTransform: "capitalize",
                  }}
                >
                  {getItemName(selectedItem)}
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Roboto",
                    fontSize: "16px",
                    fontWeight: "800",
                    lineHeight: "18px",
                    color: palette.accent,
                    pt: "8px",
                  }}
                >
                  {getItemPrice(selectedItem)}
                </Typography>
                {getItemDescription(selectedItem) && (
                  <Typography
                    sx={{
                      fontFamily: "Roboto",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "21px",
                      color: palette.textMuted,
                      pt: "12px",
                    }}
                  >
                    {getItemDescription(selectedItem)}
                  </Typography>
                )}
                <Button
                  fullWidth
                  onClick={handleClose}
                  sx={{
                    mt: "20px",
                    borderRadius: "14px",
                    py: "12px",
                    bgcolor: palette.accent,
                    color: palette.onAccent,
                    fontFamily: "Roboto",
                    fontSize: "14px",
                    fontWeight: "800",
                    textTransform: "none",
                    "&:hover": { bgcolor: palette.accentBlue },
                  }}
                >
                  Back to menu
                </Button>
              </Box>
            </>
          )}
        </Box>
      </Modal>
    </Box>
  );
};

export default Test;
